import Globals from "../Globals.js";
import DataManager from "./DataManager.js";
import PageCommon from "./PageCommon.js";
import SearchManager from "./SearchManager.js";
import PlayerManager from "./PlayerManager.js";
import UserManager from "./UserManager.js";
import VideoManager from "./VideoManager.js";
import IndexedDBManager from "./IndexedDBManager.js";
import LicensesManager from "./LicensesManager.js";

export default class PageShow extends PageCommon {
    constructor() {
        super();
        if (Globals.SHOW_ALL_CONSOLE_LOG) console.log("PageShow - constructor");
        this.pageName = "";
        this.renderedHTML = [];
        this.dataManager = new DataManager();
        this.searchManager = new SearchManager();
        this.playerManager = new PlayerManager();
        this.videoManager = new VideoManager();
        this.userManager = new UserManager();
        this.indexedDBManager = new IndexedDBManager();
        this.licensesManager = new LicensesManager();

        this.scrollOffsetCompress = 10;
        this.timeoutUploadedVideo = 3600;
    }

    init({ pageName }) {
        super.init();
        if (Globals.SHOW_ALL_CONSOLE_LOG) console.log("PageShow - init");

        this.showPreloader(true);

        this.resetUploadedVideo();

        this.pageName = pageName;

        const _this = this;

        document.addEventListener("user_ready", (event) => {
            if (Globals.SHOW_ALL_CONSOLE_LOG) console.log("%cPageShow - User Ready", "color: orange");
            if (event.detail.loadDataManager) {
                if (Globals.SHOW_ALL_CONSOLE_LOG) console.log("%cPageShow - Init DataManager", "color: orange");
                _this.dataManager.init();
            }
        });

        document.addEventListener("data_ready", () => {
            if (Globals.SHOW_ALL_CONSOLE_LOG) console.log("%cPageShow - Data Ready", "color: orange");
            // if (Globals.SHOW_ALL_CONSOLE_LOG) console.log(_this.dataManager.dataStructure);
            _this.showPage();
            _this.showPreloader(false);
            if (this.pageName !== "licenses") {
                _this.setFrontendFunctions();
            }
            _this.autoFillPlayerFromLocalStorage();
            _this.autoLoadVideo();
        });

        document.addEventListener("playlists_update", () => {
            if (Globals.SHOW_ALL_CONSOLE_LOG) console.log("PageShow - User Ready");
            _this.reloadMyplaylist();
        });

        document.addEventListener("page_rendered", () => {
            if (Globals.SHOW_ALL_CONSOLE_LOG) console.log("PageShow - Page Rendered");

            const token = this.getCookie("user_token");
            const urlParams = this.getUrlParams();

            if (!token && urlParams.get("token")) {
                this.setCookie("user_token", urlParams.get("token"));
                urlParams.delete("token");
                console.log(urlParams);
                window.location.search = urlParams.toString();
            }

            _this.userManager.setDataManager(_this.dataManager);

            if (Globals.SHOW_ALL_CONSOLE_LOG) console.log("%cPageShow - Set Current User", "color: orange");
            _this.userManager.setCurrentUser({ loadDataManager: true });

            _this.videoManager.run({ indexedDB: _this.indexedDBManager });

            /* // --- Random HP Background
            const hpCanvasBk = document.querySelectorAll(".hp-canvas");
            if (hpCanvasBk.length == 1) hpCanvasBk[0].style.backgroundImage = "url('/dist/assets/" + (Math.floor(Math.random() * 5) + 2) + ".jpg')";
            //*/
        });

        document.addEventListener("all_data_loaded", () => {
            _this.setFrontendFunctions();
        });

        this.renderPage();
    }

    autoFillPlayerFromLocalStorage() {
        if (window.localStorage.getItem("playing_track_id")) {
            const id = window.localStorage.getItem("playing_track_id");
            const target = Array.from(document.querySelectorAll(".track-item")).filter((item) => item.dataset.id === id)[0];
            this.emitEvent("track_clicked", { detail: { id, target, autoload: true } });
        } else {
            if (document.querySelector("#playerBlock")) {
                document.querySelector("#playerBlock").style.cssText += ";display:none !important;";
            }
        }
    }

    resetUploadedVideo() {
        const lastPageLoaded = window.localStorage.getItem("last_page_loaded_timestamp");
        const now = parseInt(new Date().getTime() / 1000);

        window.localStorage.setItem("last_page_loaded_timestamp", now);

        if (now > +lastPageLoaded + this.timeoutUploadedVideo) {
            window.localStorage.setItem("delete_indexDB", true);
        }
    }

    autoLoadVideo() {
        const _this = this;
        document.addEventListener("player_ready", () => {
            _this.indexedDBManager.open();
            document.addEventListener("idb_ready", () => {
                const deleteIndexDBForTimeout = window.localStorage.getItem("delete_indexDB");
                if (deleteIndexDBForTimeout) {
                    _this.indexedDBManager.delete(1);
                    window.localStorage.removeItem("delete_indexDB");
                } else {
                    _this.indexedDBManager.read(1);
                }
            });

            const youtubeUrl = window.localStorage.getItem("youtube_video_url");
            if (youtubeUrl) {
                _this.emitEvent("youtube_video_found", { detail: { url: youtubeUrl } });
                if (_this.pageName === "find-music") {
                    document.body.classList.add("video-uploaded");
                }
            }

            // AI Video
            /*
            if (window.location.origin === "https://sz-web01-test.azurewebsites.net" || window.location.origin.indexOf("https://localhost") >= 0) {
                const li = document.createElement("li");
                li.className = "nav-item";
                const link = document.createElement("a");
                link.className = "nav-link d-none d-md-block";
                link.href = "/match-video-ai";
                link.textContent = "AI TOOL";
                li.append(link);
                document.querySelector(".navbar-nav .nav-item:nth-child(2)").after(li);
            }
            //*/

        });
    }

    setupIndexedDB(windowIndexedDB) {
        this.indexedDBManager.init({ windowIndexedDB, dbName: "videos_db" });
    }

    isStaticPage(page) {
        return (
            [
                "index",
                "team-pricing",
                "licenses",
                "pricing",
                "profile",
                "artist-profile",
                "support",
                "faq",
                "faq-artist",
                "become-an-artist",
                "team-licensing",
                "privacy",
                "free-trial",
                "about-us",
                "ask-us",
                "placements",
                "thank-you",
                "tutorial",
                "match-video-mobile",
                "match-video-ai",
            ].indexOf(page) > -1
        );
    }

    renderPage() {
        const path = this.pageName === "index" ? "Pages/" : "";

        // Common
        this.injectHTML(".library-template", "library-template.html");
        this.injectHTML(".main-header", "main-header.html", path, [
            {
                id: "#playlistsHeaderSection",
                file: "section-playlists-header.html",
            },
        ]);
        this.injectHTML(".fm-searchbar-container", "searchbar-container.html");
        this.injectHTML(".sync-tool-container", "sync-tool.html", null, [
            {
                id: "#videoBlock",
                file: "video.html",
            },
        ]);
        this.injectHTML("#playerBlock", "player.html");
        this.injectHTML("#mobilePlayerBlock", "mobilePlayer.html");
        this.injectHTML(".fm-nav-container", "nav-container.html");
        this.injectHTML(".main-footer", "main-footer.html", path);

        // Find Music
        this.injectHTML("#playlistsSection", "section-playlists-swiper.html");
        this.injectHTML("#tracksSection .tracks-list", "tracks-list.html");
        this.injectHTML("#producersBlock", "block-producers.html");
        this.injectHTML("#artistsBlock", "block-artists.html");
        this.injectHTML("#albumsBlock", "block-albums.html");
        this.injectHTML("#labelsBlock", "block-labels.html");

        // Artist
        this.injectHTML("#artistSection", "section-artist-single.html");
        // Artists
        this.injectHTML("#artistsListSection", "section-artists-list.html");

        // Playlist
        this.injectHTML("#playlistSection", "section-playlist-single.html");
        // Playlists
        this.injectHTML("#playlistsListSection", "section-playlists-list.html");

        // Album
        this.injectHTML("#albumSection", "section-album-single.html");
        // Albums
        this.injectHTML("#albumsListSection", "section-albums-list.html");

        // Label
        this.injectHTML("#labelSection", "section-label-single.html");
        // Labels
        this.injectHTML("#labelsListSection", "section-labels-list.html");

        // Modal
        this.injectHTML("#modals", "modals.html", null, [
            {
                id: "#playlistModal",
                file: "modal-playlist-create.html",
            },
            {
                id: "#playlistDeleteModal",
                file: "modal-playlist-delete.html",
            },
            {
                id: "#playlistRemoveTrackModal",
                file: "modal-playlist-remove-track.html",
            },
            {
                id: "#playlistAddTrackOKModal",
                file: "modal-playlist-add-track-ok.html",
            },
            {
                id: "#playlistAddTrackERRORModal",
                file: "modal-playlist-add-track-error.html",
            },
            {
                id: "#loginModal",
                file: "modal-login.html",
                path: path,
            },
            {
                id: "#registerModal",
                file: "modal-register.html",
                path: path,
            },
            {
                id: "#showSubscriptionRegisterModal",
                file: "modal-showsubscription-register.html",
                path: path,
            },
            {
                id: "#notLoggedModal",
                file: "modal-not-logged.html",
            },
            {
                id: "#artistModal",
                file: "modal-artist.html",
            },
            {
                id: "#loadingModal",
                file: "modal-loading.html",
            },
            {
                id: "#videoErrorModal",
                file: "modal-video-error.html",
            },
            {
                id: "#licensesStatusModal",
                file: "modal-licenses-status.html",
            },
            {
                id: "#territoryModal",
                file: "modal-territory.html",
            },
            {
                id: "#territoryProceedModal",
                file: "modal-territory-proceed.html",
            },
            {
                id: "#profileEditModal",
                file: "modal-profile-edit.html",
            },
            {
                id: "#artistProfileEditModal",
                file: "modal-artist-profile-edit.html",
            },
            {
                id: "#profileUpdateStatusModal",
                file: "modal-profile-update-status.html",
            },
            {
                id: "#genericStatusModal",
                file: "modal-generic-status.html",
            },
        ]);
    }

    injectHTML(element, file, path, group) {
        const container = document.querySelector(element);
        if (container) {
            this.renderedHTML.push(element);
            fetch(`${Globals.URL_FETCH_BLOCK}${file}`)
                .then((data) => data.text())
                .then((html) => {
                    let content = html;
                    if (path) {
                        content = html
                            .replace(/href=\"(?!index.html)([a-zA-Z0-9.\-]*)\"/g, `href=\"${path}$1\"`)
                            .replace(/img src="..\/assets/g, 'img src="assets')
                            .replace(/href=\"..\/index.html\"/g, `href=\"index.html\"`);
                    }
                    container.innerHTML = content;
                    if (group) {
                        group.map(({ id, file, path }) => {
                            this.injectHTML(id, file, path);
                        });
                    }
                    this.renderedHTML.splice(this.renderedHTML.indexOf(element), 1);
                    if (this.renderedHTML.length === 0) {
                        this.emitEvent("page_rendered");
                    }
                    return;
                })
                .catch((error) => Globals.SHOW_ALL_CONSOLE_LOG && console.log("ERROR injectHTML", file, error));
        }
    }

    showPage() {
        const dataStructure = this.dataManager.dataStructure;
        const urlParams = this.getUrlParams();

        const _this = this;

        if (!this.isStaticPage(this.pageName)) {
            dataStructure.filters.renderList(this.searchManager);
            dataStructure.playlists.renderMyplaylistsList(this.userManager);
            dataStructure.tracks.setUserManager(this.userManager);
            dataStructure.tracks.setPlaylists(dataStructure.playlists);
            document.body.addEventListener("keydown", (event) => {
                if (event.target.tagName !== "INPUT" && event.target.tagName !== "TEXTAREA") {
                    const keyCode = _this.getKeyCode(event);
                    if (keyCode === "Space") {
                        event.preventDefault();
                        const audio = _this.playerManager.player.querySelector("audio");
                        if (audio.paused) {
                            _this.emitEvent("track_play");
                            _this.emitEvent("video_play");
                        } else {
                            _this.emitEvent("track_pause");
                            _this.emitEvent("video_pause");
                        }
                        return true;
                    }
                    else if (keyCode === "ArrowLeft") {
                        _this.emitEvent("audio_backward");
                    }
                    else if (keyCode === "ArrowRight") {
                        _this.emitEvent("audio_forward");
                    }
                    else if (keyCode === "ArrowUp") {
                        _this.emitEvent("audio_prev");
                        if (_this.playerManager.player) event.preventDefault();
                    }
                    else if (keyCode === "ArrowDown") {
                        _this.emitEvent("audio_next");
                        if (_this.playerManager.player) event.preventDefault();
                    }
                }
                return false;
            });
            document.querySelector(".fm-searchbar").classList.add("fm-searchbar--small");
            // window.addEventListener("scroll", () => {
            //     if (window.scrollY >= _this.scrollOffsetCompress) {
            //         document.querySelector(".fm-searchbar").classList.add("fm-searchbar--small");
            //     } else {
            //         document.querySelector(".fm-searchbar").classList.remove("fm-searchbar--small");
            //     }
            // });
        }

        document.addEventListener("match_video_to_track", (event) => {
            const id = event.detail.track.ID;
            if (document.querySelector("#playerBlock")) {
                const target = Array.from(document.querySelectorAll("#tracksSection .track-item")).filter((item) => item.dataset.id === id)[0];
                document.querySelector(".sync-tool").style.display = "";
                document.querySelector("#playerBlock").style.display = "";
                _this.emitEvent("track_clicked", { detail: { id, target, autoload: true } });
            } else {
                window.localStorage.setItem("playing_track_id", id);
                return (window.location.href = "/match-video");
            }
        });

        this.licensesManager.init({
            pageName: this.pageName,
            tracks: dataStructure.tracks,
            artists: dataStructure.artists,
            artists_formats: dataStructure.artists_formats,
            userManager: this.userManager,
        });

        if (window.location.pathname !== "/") {
            const mainMenu = document.querySelector("#mainMenu");
            const menuItems = mainMenu.querySelectorAll(".nav-item");
            Array.from(menuItems).map((item) => {
                const link = item.querySelector("a.nav-link");
                if (link.href.indexOf("#") === -1 && link.href.startsWith(window.location.href)) {
                    link.classList.add("active");
                } else {
                    const sublinks = item.querySelectorAll("a.dropdown-item");
                    Array.from(sublinks).map((sublink) => {
                        if (sublink.href.indexOf("#") === -1 && sublink.href.startsWith(window.location.href)) {
                            link.classList.add("active");
                            sublink.classList.add("active");
                        }
                    });
                }
            });
        }

        switch (this.pageName) {
            case "find-music":
            case "match-video":
                if (this.pageName === "match-video") {
                    document.querySelector(".sync-tool").style.display = "";
                }
                dataStructure.tracks.renderFirstpageList();
                dataStructure.playlists.renderFirstpageList();
                dataStructure.artists.renderFirstpageList("producers");
                dataStructure.artists.renderFirstpageList("artists");
                dataStructure.albums.renderFirstpageList();
                dataStructure.labels.renderFirstpageList();
                this.setupNavigation(
                    [
                        "#sideMenu a",
                        "#playlistsMenu a",
                        "#contentWrapper #playlistsSection a",
                        "#contentWrapper #tracksSection a",
                        "#producersBlock a",
                        "#artistsBlock a",
                        "#albumsBlock a",
                        "#labelsBlock a",
                    ],
                    false
                );
                //     window.addEventListener("beforeunload", (event) => {
                //       const video = document.querySelector("video#uploadedVideo");
                //     if (video.src.startsWith("blob:")) {
                //       event.preventDefault();
                //     event.returnValue = `You exiting from the page. The video will need to be uploaded again.`;
                // document.querySelector("#genericStatusModal .medium-title").textContent = "NOTICE";
                // document.querySelector("#genericStatusModal .message").innerHTML = "You exiting from the page. The video will need to be uploaded again.";
                // jQuery("#genericStatusModal").modal("show");
                // setTimeout(() => {
                //     document.querySelector("#genericStatusModal .medium-title").textContent = "";
                //     document.querySelector("#genericStatusModal .message").textContent = "";
                //     jQuery("#genericStatusModal").modal("hide");
                // }, 10000);
                //  }
                //});

                // if (this.userManager.userLogged) {
                // if (this.userManager.isActiveSubscription()) {
                document.querySelector("#videoBlock .video-container .ai-video").style.display = "flex";
                // }
                // }

                // 250506 - AI Music Generator
                if (this.userManager.userLogged) {
                    if ([1, 5,  3, 2196, 252, 966, 397].includes(this.userManager.userLogged.ID)) {
                        document.querySelector("#videoBlock .video-container .ai-music").style.display = "flex";
                    }
                }

                break;
            case "artist":
                dataStructure.artists.renderSingle(urlParams.get("id"), dataStructure.tracks);
                this.setupNavigation(["#sideMenu a", "#playlistsMenu a", "#contentWrapper #artistSection a", "#contentWrapper #tracksSection a"], true);
                break;
            case "artists":
                dataStructure.artists.renderList(urlParams.get("format"), "artistsList");
                this.setupNavigation(["#sideMenu a", "#playlistsMenu a", "#contentWrapper #artistsListSection a"], true);
                document.querySelector("#tracksSection").style.display = "none";
                break;
            case "playlist":
                dataStructure.playlists.renderSingle(urlParams.get("id"), dataStructure.tracks, this.userManager);
                this.setupNavigation(["#sideMenu a", "#playlistsMenu a", "#contentWrapper #playlistSection a"], true);
                // Fix per lentezza caricamento dati
                setTimeout(() => {
                    this.setupNavigation(["#contentWrapper #tracksSection a"], true);
                }, 1000);
                break;
            case "playlists":
                dataStructure.playlists.renderList();
                this.setupNavigation(["#sideMenu a", "#playlistsMenu a", "#contentWrapper #playlistsListSection a"], false);
                document.querySelector("#tracksSection").style.display = "none";
                break;
            case "album":
                dataStructure.albums.renderSingle(urlParams.get("id"), dataStructure.tracks);
                this.setupNavigation(["#sideMenu a", "#playlistsMenu a", "#contentWrapper #albumSection a", "#contentWrapper #tracksSection a"], true);
                break;
            case "albums":
                dataStructure.albums.renderList();
                this.setupNavigation(["#sideMenu a", "#playlistsMenu a", "#contentWrapper #albumsListSection a"], true);
                document.querySelector("#tracksSection").style.display = "none";
                break;
            case "label":
                dataStructure.labels.renderSingle(urlParams.get("id"), dataStructure.tracks);
                this.setupNavigation(["#sideMenu a", "#playlistsMenu a", "#contentWrapper #labelSection a", "#contentWrapper #tracksSection a"], true);
                break;
            case "labels":
                dataStructure.labels.renderList();
                this.setupNavigation(["#sideMenu a", "#playlistsMenu a", "#contentWrapper #labelsListSection a"], true);
                document.querySelector("#tracksSection").style.display = "none";
                break;
            case "licenses":
                this.licensesManager.getPageData({ payment: urlParams.get("payment") });
                break;
            case "profile":
                if (!this.userManager.userLogged) {
                    window.location.href = "/find-music";
                    return;
                }
                this.userManager.profiles.profile.init({
                    user: this.userManager.userLogged,
                    tracks: dataStructure.tracks,
                    artists: dataStructure.artists,
                    countries: dataStructure.countries,
                });
                this.userManager.profiles.profile.showPage({ payment: urlParams.get("payment") });
                break;
            case "artist-profile":
                if (!this.userManager.userLogged || !this.userManager.userLogged.is_artist) {
                    window.location.href = "/find-music";
                    return;
                }
                this.userManager.profiles.artistProfile.init({
                    user: this.userManager.userLogged,
                    tracks: dataStructure.tracks,
                    artists: dataStructure.artists,
                    playlists: dataStructure.playlists,
                    countries: dataStructure.countries,
                });
                this.userManager.profiles.artistProfile.showPage();
                break;
            case "faq":
                this.userManager.profiles.profile.init({ user: this.userManager.userLogged, tracks: dataStructure.tracks, artists: dataStructure.artists });
                this.userManager.profiles.profile.buySubscription();
                this.dataManager.renderFaqData();
                break;
            case "faq-artist":
                this.userManager.profiles.profile.init({ user: this.userManager.userLogged, tracks: dataStructure.tracks, artists: dataStructure.artists });
                this.userManager.profiles.profile.buySubscription();
                this.dataManager.renderFaqArtistData();
                break;
            case "index":
                this.dataManager.renderPlacementsData(1);
            case "pricing":
                this.userManager.profiles.profile.init({ user: this.userManager.userLogged, tracks: dataStructure.tracks, artists: dataStructure.artists });
                this.userManager.profiles.profile.buySubscription();
                this.dataManager.activateInputPromoCode();
                this.dataManager.renderSubscriptionData();
                if (window.location.hash && this.pageName === "pricing") {
                    setTimeout(() => {
                        document.getElementById(window.location.hash.substring(1)).scrollIntoView();
                    }, 100);
                }
                break;
            case "free-trial":
                if (Globals.SHOW_ALL_CONSOLE_LOG) console.log("%cFree Trial", "color: orange");
                if (this.userManager.userLogged) {
                    document.querySelector(".free-trial .ftUserMode").addEventListener("click", () => {
                        this.userManager.profiles.profile.buyFreeTrial();
                    });
                }
                document.querySelector(".form-container .reg-intro").innerHTML = 'Register for 30 days free trial';
                break;
            case "thank-you":
                if (urlParams.has("order")) {
                    document.querySelector(".thank-you-lic").style.display = "";
                    ("" + urlParams.get("digital")).split(",").forEach((el) => {
                        switch (el) {
                            case "3693":
                                gtag("event", "conversion", { 'send_to': "AW-658118760/wL0zCODUmNsCEOiw6LkC", 'transaction_id': "" });
                                break;
                            case "3705":
                                gtag("event", "conversion", { 'send_to': "AW-658118760/-4WACNGDndsCEOiw6LkC", 'transaction_id': "" });
                                break;
                            case "3706":
                                gtag("event", "conversion", { 'send_to': "AW-658118760/a_XaCJGLndsCEOiw6LkC", 'transaction_id': "" });
                                break;
                            case "3708":
                                gtag("event", "conversion", { 'send_to': "AW-658118760/oGOWCJDd9NoCEOiw6LkC", 'transaction_id': "" });
                                break;
                            case "3694":
                                gtag("event", "conversion", { 'send_to': "AW-658118760/62aoCKfu9NoCEOiw6LkC", 'transaction_id': "" });
                                break;
                        }
                    });
                    ("" + urlParams.get("single")).split(",").forEach((el) => {
                        if (el == "1") gtag("event", "conversion", { 'send_to': "AW-658118760/2tCHCOW-pOUDEOiw6LkC", 'transaction_id': "" });
                    });
                } else if (urlParams.has("contract")) {
                    if (urlParams.get("contract") == "1.T") {
                        document.querySelector(".thank-you-free").style.display = "";
                        gtag("event", "conversion", { 'send_to': "AW-658118760/aPQZCLHBmcsBEOiw6LkC", 'transaction_id': "" });
                    } else {
                        document.querySelector(".thank-you-sub").style.display = "";
                        switch (urlParams.get("contract")) {
                            case "2.M":
                                gtag("event", "conversion", { 'send_to': "AW-658118760/wXzDCOeOmdsCEOiw6LkC", 'transaction_id': "" });
                                break;
                            case "2.Y":
                                gtag("event", "conversion", { 'send_to': "AW-658118760/mZNRCNHQnNsCEOiw6LkC", 'transaction_id': "" });
                                break;
                            case "4.M":
                                gtag('event', 'conversion', { 'send_to': 'AW-658118760/9HAlCKOmpOUDEOiw6LkC', 'transaction_id': '' });
                                break;
                            case "4.Y":
                                gtag("event", "conversion", { 'send_to': "AW-658118760/tpQBCI7hnNsCEOiw6LkC", 'transaction_id': "" });
                                break;
                        }
                    }
                }
                break;
            case "ask-us":
                this.userManager.profiles.profile.init({ user: this.userManager.userLogged, tracks: dataStructure.tracks, artists: dataStructure.artists });
                this.userManager.profiles.profile.buySubscription();
                let subscription = true;
                if (this.userManager.userLogged && this.userManager.profiles.profile.data.subscriptions) {
                    //subscription = this.userManager.profiles.profile.data.subscriptions.filter((sub) => sub.type === 4)[0];
                    subscription = this.userManager.profiles.profile.data.subscriptions.filter((sub) => sub.type === "4")[0]; // Confronto con stringa
                }
                if (this.userManager.userLogged && subscription) {
                    document.querySelector(".ask-us-unlogged").style.display = "none";
                    document.querySelector(".ask-us-logged").style.display = "";
                    const form = document.querySelector(".ask-us-logged form");

                    form.querySelector("input[type=file]").addEventListener("change", (event) => {
                        form.querySelector(".custom-file-input .not-uploaded").style.display = "none";
                        form.querySelector(".custom-file-input .uploaded .filename").textContent = event.target.files[0].name;
                        form.querySelector(".custom-file-input .uploaded").style.display = "";
                    });

                    form.addEventListener("submit", (event) => {
                        event.preventDefault();
                        const formData = new FormData(form);
                        this.sendAskusData(this.userManager, formData);
                    });
                } else {
                    this.dataManager.renderSubscriptionData();
                }
                break;
            case "placements":
                this.userManager.profiles.profile.init({ user: this.userManager.userLogged, tracks: dataStructure.tracks, artists: dataStructure.artists });
                this.userManager.profiles.profile.buySubscription();
                this.dataManager.renderPlacementsData(0);
                break;
            case "team-pricing":
            case "support":
            case "become-an-artist":
            case "team-licensing":
            case "about-us":
            case "tutorial":
            case "match-video-ai":
                document.querySelector(".ai-tool-req-link");
                // ---
                const atrl = document.querySelector(".ai-tool-req-link");
                if (atrl != null && typeof atrl !== 'undefined') { 
                    if (this.userManager.userLogged) {
                        atrl.href = "?mode=TOOL.REQ&token=" + this.getCookie("user_token");
                    } else {
                        atrl.setAttribute("data-target", "#loginModal");
                        atrl.setAttribute("data-toggle", "modal");
                    }
                }
                break;
            case "match-video-mobile":
                this.userManager.profiles.profile.init({ user: this.userManager.userLogged, tracks: dataStructure.tracks, artists: dataStructure.artists });
                this.userManager.profiles.profile.buySubscription();
                break;
            default:
                break;
        }

        if (urlParams.get("kw")) {
            this.searchManager.searchTracks(urlParams.get("kw"), "tags");
        }
        dataStructure.playlists.renderHeaderList(3);
        dataStructure.filters.renderHeaderList("Genre", 3);
        dataStructure.filters.renderHeaderList("Mood", 3);
    }

    setupNavigation(elements, showSideMenu) {
        this.setupNavigationLinks(elements);
        if (showSideMenu) {
            document.querySelector("#sideMenu").style.display = "";
        }
        document.addEventListener("search_result_rendered", () => {
            this.setupNavigationLinks(["#tracksSection a"]);
        });
        window.addEventListener("popstate", (event) => {
            if (!Globals.isRemoveTrackFromPlaylist) window.location.reload();
        });
    }

    setupNavigationLinks(elements) {
        elements.map((element) => {
            const links = document.querySelectorAll(element);
            this.swapLinksToEvents(links, this.dataManager.dataStructure, this.userManager);
        });
    }

    setFrontendFunctions() {
        let trg = jQuery("#loginModal");
        if (trg.hasClass("alreadyInited")) {
            return;
        }
        trg.addClass("alreadyInited");

        bindEvents();
        setPlugins();

        this.userManager.setUserEvents();
        if (!this.isStaticPage(this.pageName)) {
            this.searchManager.init({
                pageName: this.pageName,
                dataStructure: this.dataManager.dataStructure,
                userManager: this.userManager,
            });
            this.playerManager.init({
                tracks: this.dataManager.dataStructure.tracks,
                playlists: this.dataManager.dataStructure.playlists,
                artists: this.dataManager.dataStructure.artists,
                albums: this.dataManager.dataStructure.albums,
                userManager: this.userManager,
            });
            if (this.userManager.userLogged) {
                this.dataManager.dataStructure.playlists.setupNewPlaylist();
            }
        }
    }

    reloadMyplaylist() {
        this.userManager.setCurrentUser({ loadDataManager: false });
        document.addEventListener("user_ready", (event) => {
            this.dataManager.dataStructure.playlists.renderMyplaylistsList(this.userManager);
            this.playerManager.updateDropdown();

            const urlParams = this.getUrlParams();

            if (urlParams.get("kw")) {
                this.searchManager.searchTracks(null, "tags");
            }

            switch (this.pageName) {
                case "find-music":
                case "match-video":
                    this.dataManager.dataStructure.tracks.renderFirstpageList();
                    this.setupNavigationLinks(["#playlistsMenu a"]);
                    break;
                case "artist":
                    this.dataManager.dataStructure.artists.renderSingle(urlParams.get("id"), this.dataManager.dataStructure.tracks);
                    break;
                case "artists":
                    this.dataManager.dataStructure.artists.renderList(urlParams.get("format"), "artistsList");
                    break;
                case "playlist":
                    this.dataManager.dataStructure.playlists.renderSingle(urlParams.get("id"), this.dataManager.dataStructure.tracks, this.userManager);
                    break;
                case "playlists":
                    this.dataManager.dataStructure.playlists.renderList();
                    break;
                case "album":
                    this.dataManager.dataStructure.albums.renderSingle(urlParams.get("id"), this.dataManager.dataStructure.tracks);
                    break;
                case "albums":
                    this.dataManager.dataStructure.albums.renderList();
                    break;
                default:
                    break;
            }
        });
    }
}
